import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  const navItems = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Meet Us',
    path: '/meet-us'
  }, {
    name: 'Programs',
    path: '/programs'
  }, {
    name: 'Testimonials',
    path: '/testimonials'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <footer className="w-full bg-gradient-to-b from-gold-50 to-white border-t border-gray-200 py-12" data-id="element-410">
      <div className="container mx-auto px-4" data-id="element-411">
        <div className="flex flex-col md:flex-row justify-between items-center mb-12" data-id="element-412">
          <div className="mb-8 md:mb-0 text-center" data-id="element-413">
            <Link to="/" data-id="element-414">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6enBba7nGTipGJpvGovp6X/IMG_1828.jpg" alt="The Legacy Lab - Wealth Acceleration" className="h-20 object-contain mb-2 mx-auto" data-id="element-415" />
            </Link>
            <p className="text-gray-600 mt-2" data-id="element-416">
              Building wealth. Creating legacies.
            </p>
          </div>
          <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4" data-id="element-417">
            {navItems.map(item => <Link key={item.name} to={item.path} className="text-gray-600 hover:text-gold-500 transition-colors nav-link" data-id="element-418">
                {item.name}
              </Link>)}
          </nav>
        </div>
        <div className="elegant-divider mb-8" data-id="element-419"></div>
        <div className="text-center" data-id="element-420">
          <p className="text-gray-600 mb-4" data-id="element-421">
            © 2025 Legacy Lab Financial. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm max-w-4xl mx-auto" data-id="element-422">
            Legacy Lab is for educational use only. Curtis Eatmon IV and Max
            Life Agency LLC do not offer legal, tax, or investment advice. All
            strategies and tools provided are intended to inform and empower
            personal financial decision-making. Results are not guaranteed. Use
            of proprietary methods, including PDA strategies and liquidity
            structures, without permission is prohibited.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;